/**
 * Announce a message to screen readers via the persistent live region.
 * Clears first, then sets, to force a DOM change that screen readers will read.
 */
export function announce(msg: string, opts?: { delay?: number }) {
    const node = document.getElementById('sr-announcer');
    if (!node) return;
    node.textContent = '';
    const delay = opts?.delay ?? 50;
    window.setTimeout(() => {
        node.textContent = msg;
    }, delay);
}
